export default __webpack_public_path__ + "static/media/390.6b44e1a8.png";